var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIdCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#397ADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0188 30.9254H25.1791V25.2217H30.9172V23.0615H25.1791V17.0828H23.0188V23.0615H17.0746V25.2217H23.0188V30.9254ZM24.0061 37.9535C22.0774 37.9535 20.2673 37.5884 18.5759 36.8582C16.8845 36.1279 15.4052 35.1292 14.138 33.862C12.8708 32.5948 11.8721 31.115 11.1418 29.4227C10.4116 27.7303 10.0465 25.9188 10.0465 23.9881C10.0465 22.0573 10.4116 20.2454 11.1418 18.5523C11.8721 16.8592 12.8704 15.3846 14.1367 14.1286C15.403 12.8726 16.8826 11.8782 18.5753 11.1455C20.2681 10.4129 22.0801 10.0465 24.0112 10.0465C25.9424 10.0465 27.7549 10.4126 29.4487 11.1449C31.1424 11.8772 32.6171 12.871 33.8727 14.1263C35.1283 15.3816 36.1224 16.8577 36.8548 18.5547C37.5873 20.2517 37.9535 22.0651 37.9535 23.995C37.9535 25.9245 37.5871 27.7349 36.8544 29.4262C36.1218 31.1176 35.1274 32.5944 33.8714 33.8567C32.6154 35.119 31.1393 36.1174 29.4433 36.8518C27.7473 37.5863 25.9349 37.9535 24.0061 37.9535ZM24.0131 35.6125C27.2324 35.6125 29.9691 34.4815 32.2232 32.2194C34.4773 29.9574 35.6043 27.2132 35.6043 23.9869C35.6043 20.7676 34.4794 18.0309 32.2296 15.7768C29.9799 13.5227 27.2339 12.3957 23.9917 12.3957C20.7811 12.3957 18.0444 13.5206 15.7816 15.7704C13.5188 18.0201 12.3874 20.7661 12.3874 24.0082C12.3874 27.2189 13.5185 29.9556 15.7806 32.2184C18.0426 34.4812 20.7868 35.6125 24.0131 35.6125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIdCar);
export default __webpack_public_path__ + "static/media/add_id_car.ad4535bf88236d5efd6127e781917ad2.svg";
export { ForwardRef as ReactComponent };